// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/accessreview/v1/accessreview_actions.proto" (package "c1.api.accessreview.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceStartRequest
 */
export interface AccessReviewActionsServiceStartRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: bool send_kickoff_notification = 2
     */
    sendKickoffNotification: boolean;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceStartResponse
 */
export interface AccessReviewActionsServiceStartResponse {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceCloseRequest
 */
export interface AccessReviewActionsServiceCloseRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: c1.api.accessreview.v1.CloseDecision close_decision = 2
     */
    closeDecision: CloseDecision;
    /**
     * @generated from protobuf field: bool send_close_notification = 3
     */
    sendCloseNotification: boolean;
    /**
     * @generated from protobuf field: bool auto_generate_report = 4
     */
    autoGenerateReport: boolean;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceCloseResponse
 */
export interface AccessReviewActionsServiceCloseResponse {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewActionsServicePrepareCampaignRequest
 */
export interface AccessReviewActionsServicePrepareCampaignRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewActionsServicePrepareCampaignResponse
 */
export interface AccessReviewActionsServicePrepareCampaignResponse {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceRevokeRequest
 */
export interface AccessReviewActionsServiceRevokeRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: repeated string selection_ids = 2
     */
    selectionIds: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceRevokeResponse
 */
export interface AccessReviewActionsServiceRevokeResponse {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceGenerateReportRequest
 */
export interface AccessReviewActionsServiceGenerateReportRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceGenerateReportResponse
 */
export interface AccessReviewActionsServiceGenerateReportResponse {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceCampaignReminderRequest
 */
export interface AccessReviewActionsServiceCampaignReminderRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
    /**
     * @generated from protobuf field: string message = 2
     */
    message: string;
    /**
     * @generated from protobuf field: bool cc_manager = 3
     */
    ccManager: boolean;
    /**
     * @generated from protobuf field: repeated string user_ids = 4
     */
    userIds: string[];
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceCampaignReminderResponse
 */
export interface AccessReviewActionsServiceCampaignReminderResponse {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceDeleteCampaignRequest
 */
export interface AccessReviewActionsServiceDeleteCampaignRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceDeleteCampaignResponse
 */
export interface AccessReviewActionsServiceDeleteCampaignResponse {
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceResetCampaignPoliciesRequest
 */
export interface AccessReviewActionsServiceResetCampaignPoliciesRequest {
    /**
     * @generated from protobuf field: string access_review_id = 1
     */
    accessReviewId: string;
}
/**
 * @generated from protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceResetCampaignPoliciesResponse
 */
export interface AccessReviewActionsServiceResetCampaignPoliciesResponse {
}
/**
 * @generated from protobuf enum c1.api.accessreview.v1.CloseDecision
 */
export enum CloseDecision {
    /**
     * @generated from protobuf enum value: CLOSE_DECISION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: CLOSE_DECISION_REVOKED = 1;
     */
    REVOKED = 1,
    /**
     * @generated from protobuf enum value: CLOSE_DECISION_SKIP = 2;
     */
    SKIP = 2,
    /**
     * @generated from protobuf enum value: CLOSE_DECISION_NO_ACTION = 3;
     */
    NO_ACTION = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewActionsServiceStartRequest$Type extends MessageType<AccessReviewActionsServiceStartRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewActionsServiceStartRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "send_kickoff_notification", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewActionsServiceStartRequest>): AccessReviewActionsServiceStartRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.sendKickoffNotification = false;
        if (value !== undefined)
            reflectionMergePartial<AccessReviewActionsServiceStartRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewActionsServiceStartRequest): AccessReviewActionsServiceStartRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* bool send_kickoff_notification */ 2:
                    message.sendKickoffNotification = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewActionsServiceStartRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* bool send_kickoff_notification = 2; */
        if (message.sendKickoffNotification !== false)
            writer.tag(2, WireType.Varint).bool(message.sendKickoffNotification);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceStartRequest
 */
export const AccessReviewActionsServiceStartRequest = new AccessReviewActionsServiceStartRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewActionsServiceStartResponse$Type extends MessageType<AccessReviewActionsServiceStartResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewActionsServiceStartResponse", []);
    }
    create(value?: PartialMessage<AccessReviewActionsServiceStartResponse>): AccessReviewActionsServiceStartResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AccessReviewActionsServiceStartResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewActionsServiceStartResponse): AccessReviewActionsServiceStartResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewActionsServiceStartResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceStartResponse
 */
export const AccessReviewActionsServiceStartResponse = new AccessReviewActionsServiceStartResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewActionsServiceCloseRequest$Type extends MessageType<AccessReviewActionsServiceCloseRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewActionsServiceCloseRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "close_decision", kind: "enum", T: () => ["c1.api.accessreview.v1.CloseDecision", CloseDecision, "CLOSE_DECISION_"] },
            { no: 3, name: "send_close_notification", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "auto_generate_report", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AccessReviewActionsServiceCloseRequest>): AccessReviewActionsServiceCloseRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.closeDecision = 0;
        message.sendCloseNotification = false;
        message.autoGenerateReport = false;
        if (value !== undefined)
            reflectionMergePartial<AccessReviewActionsServiceCloseRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewActionsServiceCloseRequest): AccessReviewActionsServiceCloseRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* c1.api.accessreview.v1.CloseDecision close_decision */ 2:
                    message.closeDecision = reader.int32();
                    break;
                case /* bool send_close_notification */ 3:
                    message.sendCloseNotification = reader.bool();
                    break;
                case /* bool auto_generate_report */ 4:
                    message.autoGenerateReport = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewActionsServiceCloseRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* c1.api.accessreview.v1.CloseDecision close_decision = 2; */
        if (message.closeDecision !== 0)
            writer.tag(2, WireType.Varint).int32(message.closeDecision);
        /* bool send_close_notification = 3; */
        if (message.sendCloseNotification !== false)
            writer.tag(3, WireType.Varint).bool(message.sendCloseNotification);
        /* bool auto_generate_report = 4; */
        if (message.autoGenerateReport !== false)
            writer.tag(4, WireType.Varint).bool(message.autoGenerateReport);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceCloseRequest
 */
export const AccessReviewActionsServiceCloseRequest = new AccessReviewActionsServiceCloseRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewActionsServiceCloseResponse$Type extends MessageType<AccessReviewActionsServiceCloseResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewActionsServiceCloseResponse", []);
    }
    create(value?: PartialMessage<AccessReviewActionsServiceCloseResponse>): AccessReviewActionsServiceCloseResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AccessReviewActionsServiceCloseResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewActionsServiceCloseResponse): AccessReviewActionsServiceCloseResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewActionsServiceCloseResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceCloseResponse
 */
export const AccessReviewActionsServiceCloseResponse = new AccessReviewActionsServiceCloseResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewActionsServicePrepareCampaignRequest$Type extends MessageType<AccessReviewActionsServicePrepareCampaignRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewActionsServicePrepareCampaignRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewActionsServicePrepareCampaignRequest>): AccessReviewActionsServicePrepareCampaignRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewActionsServicePrepareCampaignRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewActionsServicePrepareCampaignRequest): AccessReviewActionsServicePrepareCampaignRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewActionsServicePrepareCampaignRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewActionsServicePrepareCampaignRequest
 */
export const AccessReviewActionsServicePrepareCampaignRequest = new AccessReviewActionsServicePrepareCampaignRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewActionsServicePrepareCampaignResponse$Type extends MessageType<AccessReviewActionsServicePrepareCampaignResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewActionsServicePrepareCampaignResponse", []);
    }
    create(value?: PartialMessage<AccessReviewActionsServicePrepareCampaignResponse>): AccessReviewActionsServicePrepareCampaignResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AccessReviewActionsServicePrepareCampaignResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewActionsServicePrepareCampaignResponse): AccessReviewActionsServicePrepareCampaignResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewActionsServicePrepareCampaignResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewActionsServicePrepareCampaignResponse
 */
export const AccessReviewActionsServicePrepareCampaignResponse = new AccessReviewActionsServicePrepareCampaignResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewActionsServiceRevokeRequest$Type extends MessageType<AccessReviewActionsServiceRevokeRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewActionsServiceRevokeRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "selection_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "1", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewActionsServiceRevokeRequest>): AccessReviewActionsServiceRevokeRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.selectionIds = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewActionsServiceRevokeRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewActionsServiceRevokeRequest): AccessReviewActionsServiceRevokeRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* repeated string selection_ids */ 2:
                    message.selectionIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewActionsServiceRevokeRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* repeated string selection_ids = 2; */
        for (let i = 0; i < message.selectionIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.selectionIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceRevokeRequest
 */
export const AccessReviewActionsServiceRevokeRequest = new AccessReviewActionsServiceRevokeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewActionsServiceRevokeResponse$Type extends MessageType<AccessReviewActionsServiceRevokeResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewActionsServiceRevokeResponse", []);
    }
    create(value?: PartialMessage<AccessReviewActionsServiceRevokeResponse>): AccessReviewActionsServiceRevokeResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AccessReviewActionsServiceRevokeResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewActionsServiceRevokeResponse): AccessReviewActionsServiceRevokeResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewActionsServiceRevokeResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceRevokeResponse
 */
export const AccessReviewActionsServiceRevokeResponse = new AccessReviewActionsServiceRevokeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewActionsServiceGenerateReportRequest$Type extends MessageType<AccessReviewActionsServiceGenerateReportRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewActionsServiceGenerateReportRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewActionsServiceGenerateReportRequest>): AccessReviewActionsServiceGenerateReportRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewActionsServiceGenerateReportRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewActionsServiceGenerateReportRequest): AccessReviewActionsServiceGenerateReportRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewActionsServiceGenerateReportRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceGenerateReportRequest
 */
export const AccessReviewActionsServiceGenerateReportRequest = new AccessReviewActionsServiceGenerateReportRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewActionsServiceGenerateReportResponse$Type extends MessageType<AccessReviewActionsServiceGenerateReportResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewActionsServiceGenerateReportResponse", []);
    }
    create(value?: PartialMessage<AccessReviewActionsServiceGenerateReportResponse>): AccessReviewActionsServiceGenerateReportResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AccessReviewActionsServiceGenerateReportResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewActionsServiceGenerateReportResponse): AccessReviewActionsServiceGenerateReportResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewActionsServiceGenerateReportResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceGenerateReportResponse
 */
export const AccessReviewActionsServiceGenerateReportResponse = new AccessReviewActionsServiceGenerateReportResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewActionsServiceCampaignReminderRequest$Type extends MessageType<AccessReviewActionsServiceCampaignReminderRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewActionsServiceCampaignReminderRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "cc_manager", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { maxItems: "500", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewActionsServiceCampaignReminderRequest>): AccessReviewActionsServiceCampaignReminderRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        message.message = "";
        message.ccManager = false;
        message.userIds = [];
        if (value !== undefined)
            reflectionMergePartial<AccessReviewActionsServiceCampaignReminderRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewActionsServiceCampaignReminderRequest): AccessReviewActionsServiceCampaignReminderRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                case /* string message */ 2:
                    message.message = reader.string();
                    break;
                case /* bool cc_manager */ 3:
                    message.ccManager = reader.bool();
                    break;
                case /* repeated string user_ids */ 4:
                    message.userIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewActionsServiceCampaignReminderRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        /* string message = 2; */
        if (message.message !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.message);
        /* bool cc_manager = 3; */
        if (message.ccManager !== false)
            writer.tag(3, WireType.Varint).bool(message.ccManager);
        /* repeated string user_ids = 4; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.userIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceCampaignReminderRequest
 */
export const AccessReviewActionsServiceCampaignReminderRequest = new AccessReviewActionsServiceCampaignReminderRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewActionsServiceCampaignReminderResponse$Type extends MessageType<AccessReviewActionsServiceCampaignReminderResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewActionsServiceCampaignReminderResponse", []);
    }
    create(value?: PartialMessage<AccessReviewActionsServiceCampaignReminderResponse>): AccessReviewActionsServiceCampaignReminderResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AccessReviewActionsServiceCampaignReminderResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewActionsServiceCampaignReminderResponse): AccessReviewActionsServiceCampaignReminderResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewActionsServiceCampaignReminderResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceCampaignReminderResponse
 */
export const AccessReviewActionsServiceCampaignReminderResponse = new AccessReviewActionsServiceCampaignReminderResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewActionsServiceDeleteCampaignRequest$Type extends MessageType<AccessReviewActionsServiceDeleteCampaignRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewActionsServiceDeleteCampaignRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewActionsServiceDeleteCampaignRequest>): AccessReviewActionsServiceDeleteCampaignRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewActionsServiceDeleteCampaignRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewActionsServiceDeleteCampaignRequest): AccessReviewActionsServiceDeleteCampaignRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewActionsServiceDeleteCampaignRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceDeleteCampaignRequest
 */
export const AccessReviewActionsServiceDeleteCampaignRequest = new AccessReviewActionsServiceDeleteCampaignRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewActionsServiceDeleteCampaignResponse$Type extends MessageType<AccessReviewActionsServiceDeleteCampaignResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewActionsServiceDeleteCampaignResponse", []);
    }
    create(value?: PartialMessage<AccessReviewActionsServiceDeleteCampaignResponse>): AccessReviewActionsServiceDeleteCampaignResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AccessReviewActionsServiceDeleteCampaignResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewActionsServiceDeleteCampaignResponse): AccessReviewActionsServiceDeleteCampaignResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewActionsServiceDeleteCampaignResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceDeleteCampaignResponse
 */
export const AccessReviewActionsServiceDeleteCampaignResponse = new AccessReviewActionsServiceDeleteCampaignResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewActionsServiceResetCampaignPoliciesRequest$Type extends MessageType<AccessReviewActionsServiceResetCampaignPoliciesRequest> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewActionsServiceResetCampaignPoliciesRequest", [
            { no: 1, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } }
        ]);
    }
    create(value?: PartialMessage<AccessReviewActionsServiceResetCampaignPoliciesRequest>): AccessReviewActionsServiceResetCampaignPoliciesRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessReviewId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessReviewActionsServiceResetCampaignPoliciesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewActionsServiceResetCampaignPoliciesRequest): AccessReviewActionsServiceResetCampaignPoliciesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_review_id */ 1:
                    message.accessReviewId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewActionsServiceResetCampaignPoliciesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_review_id = 1; */
        if (message.accessReviewId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessReviewId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceResetCampaignPoliciesRequest
 */
export const AccessReviewActionsServiceResetCampaignPoliciesRequest = new AccessReviewActionsServiceResetCampaignPoliciesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessReviewActionsServiceResetCampaignPoliciesResponse$Type extends MessageType<AccessReviewActionsServiceResetCampaignPoliciesResponse> {
    constructor() {
        super("c1.api.accessreview.v1.AccessReviewActionsServiceResetCampaignPoliciesResponse", []);
    }
    create(value?: PartialMessage<AccessReviewActionsServiceResetCampaignPoliciesResponse>): AccessReviewActionsServiceResetCampaignPoliciesResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AccessReviewActionsServiceResetCampaignPoliciesResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessReviewActionsServiceResetCampaignPoliciesResponse): AccessReviewActionsServiceResetCampaignPoliciesResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessReviewActionsServiceResetCampaignPoliciesResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.accessreview.v1.AccessReviewActionsServiceResetCampaignPoliciesResponse
 */
export const AccessReviewActionsServiceResetCampaignPoliciesResponse = new AccessReviewActionsServiceResetCampaignPoliciesResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.accessreview.v1.AccessReviewActionsService
 */
export const AccessReviewActionsService = new ServiceType("c1.api.accessreview.v1.AccessReviewActionsService", [
    { name: "Start", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewActionsServiceStartRequest, O: AccessReviewActionsServiceStartResponse },
    { name: "Close", localName: "close$", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewActionsServiceCloseRequest, O: AccessReviewActionsServiceCloseResponse },
    { name: "PrepareCampaign", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewActionsServicePrepareCampaignRequest, O: AccessReviewActionsServicePrepareCampaignResponse },
    { name: "Revoke", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewActionsServiceRevokeRequest, O: AccessReviewActionsServiceRevokeResponse },
    { name: "GenerateReport", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewActionsServiceGenerateReportRequest, O: AccessReviewActionsServiceGenerateReportResponse },
    { name: "CampaignReminder", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewActionsServiceCampaignReminderRequest, O: AccessReviewActionsServiceCampaignReminderResponse },
    { name: "DeleteCampaign", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewActionsServiceDeleteCampaignRequest, O: AccessReviewActionsServiceDeleteCampaignResponse },
    { name: "ResetDraftCampaignPolicies", options: { "authz.method": { role: "EDITOR" } }, I: AccessReviewActionsServiceResetCampaignPoliciesRequest, O: AccessReviewActionsServiceResetCampaignPoliciesResponse }
]);
